import broChatConfig from './config';
import broChatApi from './api';

/**
 * BroChat Agent Module
 * Exports configuration and API for the BroChat agent
 */

export { broChatConfig, broChatApi };

const broChatAgent = {
  config: broChatConfig,
  api: broChatApi,
};

export default broChatAgent;
